import { render, staticRenderFns } from "./Snackbars.vue?vue&type=template&id=5496bd42&"
import script from "./Snackbars.vue?vue&type=script&lang=js&"
export * from "./Snackbars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5496bd42')) {
      api.createRecord('5496bd42', component.options)
    } else {
      api.reload('5496bd42', component.options)
    }
    module.hot.accept("./Snackbars.vue?vue&type=template&id=5496bd42&", function () {
      api.rerender('5496bd42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Snackbars.vue"
export default component.exports